// Platform-aware shortcut hint formatting (#63).
//
// Shortcut hints are authored with macOS glyphs (⌘ ⇧ ⌥ ⌫). The actual key bindings are
// Control-based on Windows/Linux, so on those platforms the menus must show Ctrl/Shift/Alt/Del
// — naming the key the user's keyboard actually has — rather than macOS symbols the keyboard
// does not carry. On macOS the glyphs are kept as-is.

function isMac(): boolean {
  if (typeof navigator === "undefined") return false;
  const p = (navigator.platform || "") + " " + (navigator.userAgent || "");
  return /Mac|iPhone|iPad|iPod/i.test(p);
}

/**
 * Format a mac-glyph shortcut string for the current platform.
 * "⌘Z" -> "⌘Z" on macOS, "Ctrl+Z" on Windows/Linux.
 * "⌘⇧Z" -> "Ctrl+Shift+Z"; "⌫" -> "Del"; "⌘K" -> "Ctrl+K".
 */
export function fmtShortcut(mac: string): string {
  if (!mac) return "";
  if (isMac()) return mac;
  return mac
    .replace(/⌘/g, "Ctrl+")
    .replace(/⇧/g, "Shift+")
    .replace(/⌥/g, "Alt+")
    .replace(/⌦/g, "Del")
    .replace(/⌫/g, "Del");
}
